"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _actions = _interopRequireDefault(require("./actions"));

var _actionsDivider = _interopRequireDefault(require("./actionsDivider"));

var _backNav = _interopRequireDefault(require("./backNav"));

var _description = _interopRequireDefault(require("./description"));

var _heading = _interopRequireDefault(require("./heading"));

var _options = _interopRequireDefault(require("./options"));

var _preTitle = _interopRequireDefault(require("./preTitle"));

var _title = _interopRequireDefault(require("./title"));

var _children = require("../helpers/children");

var _typography = require("../Typography/typography");

var _getNativeProps = _interopRequireDefault(require("../helpers/get-native-props"));

var _compareElementType = _interopRequireDefault(require("../helpers/compare-element-type"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Header = function Header(_ref) {
  var children = _ref.children,
      borderless = _ref.borderless,
      transparent = _ref.transparent,
      contained = _ref.contained,
      withBackNavigation = _ref.withBackNavigation,
      onBack = _ref.onBack,
      props = _objectWithoutProperties(_ref, ["children", "borderless", "transparent", "contained", "withBackNavigation", "onBack"]);

  var allowedModifiers = {
    borderless: borderless,
    transparent: transparent
  };
  var classNames = ['co-header', {
    'co-header--contained': contained
  }];

  var content = _react.default.createElement("div", {
    className: "co-header__container"
  }, withBackNavigation ? _react.default.createElement(_backNav.default, {
    onClick: onBack
  }) : null, children);

  return _react.default.createElement(_styler.default, {
    classNames: classNames,
    modifiers: allowedModifiers
  }, function (styles) {
    return _react.default.createElement("header", _extends({
      className: styles
    }, (0, _getNativeProps.default)(props)), content);
  });
};

Header.propTypes = {
  /** {---} Sequence of:
   * Visual element (optional, max: 1),
   * @@<Header.Heading>@@ (required, max: 1),
   * @@<Header.Actions>@@ (optional, max: 1),
   * @@<Nav>@@ or @@<Stepper>@@ (optional, max: 1) */
  children: _propTypes.any.isRequired,
  borderless: _propTypes.bool,
  transparent: _propTypes.bool,
  contained: _propTypes.bool,
  withBackNavigation: _propTypes.bool,
  onBack: _propTypes.func
};
_heading.default.PreTitle = _preTitle.default;
Header.Heading = _heading.default;
Header.Actions = _actions.default;
Header.Actions.Divider = _actionsDivider.default;
Header.Title = _title.default;
Header.Description = _description.default;
Header.Options = _options.default; // TODO: This function will be not necessary when `SectionsGroup` is removed

/**
 * Utility function for getting the Header's title string.
 * @param header: a Header component
 * @returns The string value of Header.Title's child. Or `undefined` if nothing is found.
 */

Header.getTitleText = function (header) {
  if (header && (0, _compareElementType.default)(header, Header)) {
    var headerChildren = header.props.children;
    var heading = (0, _children.getFirstDirectChildOfTypes)(headerChildren, [_heading.default]);
    var title = heading ? (0, _children.getFirstDirectChildOfTypes)(heading.props.children, [_title.default]) : undefined;
    var h = title ? (0, _children.getFirstDirectChildOfTypes)(title.props.children, [_typography.H1, _typography.H2, _typography.H3, _typography.H4]) : undefined;
    return h ? h.props.children : undefined;
  }
};

var _default = Header;
exports.default = _default;
Header.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Header",
  "props": {
    "children": {
      "type": {
        "name": "any"
      },
      "required": true,
      "description": "{---} Sequence of:\nVisual element (optional, max: 1),\n@@<Header.Heading>@@ (required, max: 1),\n@@<Header.Actions>@@ (optional, max: 1),\n@@<Nav>@@ or @@<Stepper>@@ (optional, max: 1)"
    },
    "borderless": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "transparent": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "contained": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "withBackNavigation": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onBack": {
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    }
  }
};